import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';

@Component({
    selector: 'bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    standalone: true,
    imports: [CommonModule, MatIconModule, RouterModule],
})
export class BottomNavigationComponent {
    @Input() navigation: FuseNavigationItem[] = [];

    /**
     * Get icon for navigation item
     */
    getIcon(item: FuseNavigationItem): string {
        if (item.icon) {
            return item.icon;
        }
        
        // Default icons based on common navigation items
        switch (item.id) {
            case 'menus':
                return 'heroicons_outline:clipboard-document-list';
            case 'statistics':
                return 'heroicons_outline:chart-bar';
            case 'qr-code':
                return 'heroicons_outline:qr-code';
            case 'establishment':
                return 'heroicons_outline:building-storefront';
            default:
                return 'heroicons_outline:home';
        }
    }

    /**
     * Check if item is active
     */
    isActive(item: FuseNavigationItem): boolean {
        return item.active || false;
    }
}
